import { basePath } from "@Common/constants";
import type { GetFormListOneResponseI } from "@Common/types/bo/forms/forms";
import type { ComponentPropI } from "@Common/types/resources";
import { formatMinutesToHumanReadable } from "@Src/utils/time";
import { Link } from "@mui/material";
import {
	BooleanField,
	Datagrid,
	DeleteButton,
	EditButton,
	FunctionField,
	List,
	TextField,
} from "react-admin";

export const FormsList = (props: ComponentPropI) => {
	return (
		<List
			disableAuthentication={props.isPublic}
			sort={{ field: "id", order: "DESC" }}
		>
			<Datagrid rowClick={false}>
				<TextField source="id" />
				<FunctionField
					label="Public URL"
					render={(record: GetFormListOneResponseI) =>
						record.public_id && record.is_published === true ? (
							<Link
								href={`${basePath}/forms_public/${record.public_id}/show`}
								target="_blank"
								rel="noopener noreferrer"
							>
								Public link
							</Link>
						) : null
					}
				/>
				<TextField source="name" sortable={false} />
				<TextField source="nb_steps" label="Number of steps" sortable={false} />
				<FunctionField
					label="Max Allowed Time"
					render={(record: GetFormListOneResponseI) =>
						record.max_allowed_time
							? formatMinutesToHumanReadable(record.max_allowed_time)
							: ""
					}
					sortable={false}
				/>
				<BooleanField
					source="is_published"
					label="Is Published"
					sortable={false}
				/>
				<EditButton />
				<DeleteButton mutationMode="pessimistic" />
			</Datagrid>
		</List>
	);
};
